<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">理财系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>挖矿宝</el-breadcrumb-item>
            <el-breadcrumb-item>定期挖矿</el-breadcrumb-item>
        </el-breadcrumb>

        <el-input v-model="queryParams.period" placeholder="期数" style="width: 200px"></el-input>
        <el-button type="primary" @click="searchData" style="margin: 20px 0">搜 索</el-button>
        <el-button type="danger" @click="addMiningRegularDialog" style="margin: 20px 20px">增 加</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" fixed="left" label="ID"></el-table-column>
            <el-table-column prop="period" label="期数"></el-table-column>
            <el-table-column prop="startTime" label="开始时间">
                <template slot-scope="scope">
                    <span>{{scope.row.startTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间">
                <template slot-scope="scope">
                    <span>{{scope.row.endTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="优先级" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="上/下架" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-switch :value="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterStatus(scope.row.id,$event)"/>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" @click="updateDialog(scope.row)">编辑</el-button>
                    <el-button type="primary" @click="regularPage(scope.row.id)">管理配置</el-button>
                    <el-button type="danger" @click="deleteRegular(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="150px" :model="addData" :rules="addRules" ref="addForm">
                <el-form-item label="期数：" prop="period" style="padding-top: 20px">
                    <el-input v-model="addData.period" placeholder="期数(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="时间：" prop="time" style="padding-top: 20px">
                    <el-date-picker
                            v-model="addData.time"
                            type="datetimerange"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="优先级：" prop="sort" style="padding-top: 20px">
                    <el-input v-model="addData.sort" placeholder="优先级(正整数：0＜X≤999999999)" style="width: 500px"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="addMiningRegular">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'Regular',
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {
                    period: "",
                    page: 1,
                    size: 10
                },
                title: "新增",
                dialogVisible: false,
                loading: false,
                addData: {
                    id: "",
                    period: "",
                    startTime: "",
                    endTime: "",
                    sort: "",
                    time: []
                },
                addRules: {
                    "period": [{required: true, message: "请输入期数"}],
                    "time": [{required: true, message: "请输开始时间和结束时间"}],
                    "sort": [{required: true, message: "请输入优先级"}],
                },
                reg: /^[0-9]*$/,
            }
        },
        methods: {
            searchData() {
                this.queryParams.page = 1;
                this.getMiningRegularList();
            },
            getMiningRegularList() {
                if (this.queryParams.period != "" && !this.reg.test(this.queryParams.period)) {
                    this.$message.error('期数必须为整形数字!');
                    return;
                }

                api.getMiningRegularList(this.queryParams).then(({data}) => {
                    this.dataList = data.list;
                    this.total = data.totalCount;
                });
            },
            addMiningRegular() {
                if (this.addData.period != "" && !this.reg.test(this.addData.period)) {
                    this.$message.error('期数必须为整形数字!');
                    return;
                }
                if (this.addData.sort != "" && !this.reg.test(this.addData.sort)) {
                    this.$message.error('优先级必须为整形数字!');
                    return;
                }
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        this.addData.startTime = this.addData.time[0];
                        this.addData.endTime = this.addData.time[1];
                        this.loading = true;
                        api.createOrUpdateMiningRegular(this.addData).then(({data}) => {
                            this.$message.success('操作成功!');
                            this.loading = false;
                            this.dialogVisible = false;
                            this.getMiningRegularList();
                        });
                        setTimeout(()=>{
                            this.loading = false;
                        },1000);
                    }
                });
            },
            addMiningRegularDialog() {
                this.title = "新增";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.addData = {
                    id: row.id,
                    period: row.period,
                    startTime: row.startTime,
                    endTime: row.endTime,
                    sort: row.sort,
                    time: [row.startTime, row.endTime]
                };
                this.title = "修改";
                this.dialogVisible = true;
            },
            regularPage(id) {
                this.$router.push({
                    path: '/home/mining/regularDetail',
                    query: {
                        id: id
                    }
                });
            },
            deleteRegular(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteMiningRegular({id: id}).then(() => {
                        this.$message.success('操作成功');
                        this.getMiningRegularList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getMiningRegularList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getMiningRegularList();
            },
            alterStatus(id, status) {
                this.$confirm(status ? '确认上架吗？' : '确认下架吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateMiningRegularStatus({id: id, status: status}).then(() => {
                        this.$message.success('操作成功');
                        this.getMiningRegularList();
                    });
                }).catch(() => {
                });
            },
            clearData() {
                this.$refs["addForm"].resetFields();
                this.loading = false;
                this.title = "新增";
                this.addData = {
                    id: "",
                    period: "",
                    startTime: "",
                    endTime: "",
                    sort: "",
                    time: []
                }
            }
        },
        created() {
            this.getMiningRegularList();
        }
    };
</script>

<style lang="less" scoped>

</style>
